import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Pagination,
  Box,
} from "@mui/material";
import { convertBase64ToFileAndView } from "../../helpers/Base64ToFile";
import { showToast } from "../../helpers/ToastifyHelper";
import { displayValue } from "../../helpers/TodayDate";

interface Column {
  header: string;
  field: string;
  className?: string;
  exportFileBase64?: boolean;
  exportfileName?: string;
  style?: string;
  render?: (row: any) => React.ReactNode;
}

interface Row {
  [key: string]: any;
}

interface TableProps {
  columns: Column[];
  data: Row[];
  recordsPerPage?: number;
  isSearched?: boolean;
}

const TableComponent: React.FC<TableProps> = ({
  columns,
  data,
  recordsPerPage = 5,
  isSearched = true,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentRecords, setCurrentRecords] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const pages = Math.ceil(data.length / recordsPerPage);
    setTotalPages(pages);
  }, [data, recordsPerPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [data.length]);

  useEffect(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    setCurrentRecords(data.slice(indexOfFirstRecord, indexOfLastRecord));
    console.log(data);
  }, [currentPage, data, recordsPerPage]);

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  return (
    <div style={{ overflowX: "auto", width: "100%" }}>
      <TableContainer component={Paper}>
        <Table className="border" size="small" aria-label="simple table">
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={index}
                  style={{ verticalAlign: "middle",                    borderRight: "1px solid #ddd",
                    backgroundColor: "#f2f2f2"
                  }}
                  className={column.className}
                >
                  {column.header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentRecords.length !== 0 ? (
              currentRecords.map((item, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columns.map((column, colIndex) =>
                    column.render ? (
                      <TableCell
                        className={column.className}
                        key={colIndex}
                        style={{
                          verticalAlign: "middle",
                          fontSize: "0.95rem",
                          borderRight: "1px solid #ddd",
                        }}
                      >
                        {column.render(item)}
                      </TableCell>
                    ) : column.exportFileBase64 ? (
                      <TableCell
                        className={column.className}
                        key={colIndex}
                        style={{
                          verticalAlign: "middle",
                          fontSize: "1rem",
                          padding: "0.5rem",
                          borderRight: "1px solid #ddd",

                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            const result = convertBase64ToFileAndView(
                              item.kararIcerigiBase64,
                              "application/msword",
                              item.kararNumarasi + column.exportfileName
                            );
                            if (!result) {
                              showToast("Detay bilgisi yok", "warning");
                            }
                          }}
                        >
                          Detay
                        </Button>
                      </TableCell>
                    ) : (
                      <TableCell
                        style={{
                          verticalAlign: "middle",
                          fontSize: "0.95rem",
                          borderRight: "1px solid #ddd",

                        }}
                        className={column.className}
                        key={colIndex}
                      >
                        {displayValue(item[column.field])}
                      </TableCell>
                    )
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  style={{ fontSize: "1.0rem",   borderRight: "1px solid #ddd",
                    verticalAlign: "middle" }}
                  colSpan={columns.length}
                >
                  {isSearched ? "Kayıt Bulunamadı." : "Lütfen Arama Yapınız."}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box mt={2} display="flex" justifyContent="center">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChangePage}
          color="primary"
        />
      </Box>
    </div>
  );
};

export default TableComponent;
